import firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyAvEGQPLyEAQsWnlZfol_tyzcQC7X9u8tU",
  authDomain: "ubytes-dashboard.firebaseapp.com",
  projectId: "ubytes-dashboard",
  storageBucket: "ubytes-dashboard.appspot.com",
  messagingSenderId: "774065251125",
  appId: "1:774065251125:web:b22a1161130bc36cc7627c",
  measurementId: "G-RH8QZ73EVQ",
};
firebase.initializeApp(firebaseConfig);
export const storage = firebase.storage();
const db = firebase.firestore();
export const auth = firebase.auth();

export default db;
